import { AnalyticsBrowser } from '@segment/analytics-next';
import { ITrackingProps } from 'interfaces';
import { useCallback, useMemo } from 'react';

export const useTrack = () => {
    const analytics = useMemo(() => {
        if (!import.meta.env.VITE_ANALYTICS_KEY || import.meta.env.VITE_ANALYTICS_KEY === '') {
            return null;
        }
        return AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_ANALYTICS_KEY });
    }, []);

    const identify = useCallback(
        (email: string) => {
            if (analytics) {
                analytics.identify(email);
            }
        },
        [analytics],
    );

    const track = useCallback(
        (event: string, payload?: ITrackingProps) => {
            if (analytics) {
                analytics.track(event, payload);
            }
        },
        [analytics],
    );

    const trackWithCallback = useCallback(
        (event: string, payload?: ITrackingProps, callback?: () => void) => {
            if (analytics) {
                analytics.track(event, payload, callback);
            }
        },
        [analytics],
    );

    return { identify, track, trackWithCallback };
};
